import { Colors } from "@jsq/ds/styles";
import {
  PaymentServicePaymentBatchStatus,
  PaymentMethod,
} from "../../../graphql/supergraph.index";
import {
  PaymentMethod as PaymentMethodEnum,
  PaymentServicePaymentBatchStatus as PaymentBatchStatusEnum,
} from "../../../graphql/supergraphOperations";
import { BatchStatusUIConfig } from "../types";

export enum BatchStatusForUI {
  Approved = "Approved",
  Canceled = "Canceled",
  Denied = "Approval denied",
  Draft = "Draft",
  Failed = "Failed",
  Processing = "Processing",
  Funded = "Funded",
  FundingInProgress = "Funding in progress",
  ReadyForReview = "Ready for review",
  ReadyForClientAuthorization = "Ready for client authorization",
  Transmitted = "Transmitted",
  InProgress = "In Progress",
}
/**
 * Map of batch status filters
 * This map is prepared to be used in the filter dropdown. The key's will be provided as the filter options and
 * the corresponding values would be used to sent it to the API for the server side filtering
 */
export const batchStatusFilterTypes: Map<string, PaymentServicePaymentBatchStatus[]> = new Map([
  [BatchStatusForUI.Approved, [PaymentBatchStatusEnum.Approved]],
  [BatchStatusForUI.Canceled, [PaymentBatchStatusEnum.Canceled]],
  [
    BatchStatusForUI.Denied,
    [PaymentBatchStatusEnum.Denied, PaymentBatchStatusEnum.TreasuryDenied],
  ],
  [BatchStatusForUI.Failed, [PaymentBatchStatusEnum.Failed]],
  [
    BatchStatusForUI.InProgress,
    [PaymentBatchStatusEnum.Funded, PaymentBatchStatusEnum.FundingInProgress],
  ],
  [BatchStatusForUI.ReadyForClientAuthorization, [PaymentBatchStatusEnum.ReadyForReview]],
  [BatchStatusForUI.ReadyForReview, [PaymentBatchStatusEnum.ReadyForTreasuryReview]],
  [BatchStatusForUI.Transmitted, [PaymentBatchStatusEnum.Transmitted]],
]);

/**
 * Provides the data to be displayed with respect to each batch status
 * @param status
 * @param method
 * @returns
 */
export const batchStatusUIConfig = (
  status: PaymentServicePaymentBatchStatus,
  method?: PaymentMethod,
): BatchStatusUIConfig => {
  let displayText: string;
  let labelColor: string | undefined;
  switch (status) {
    case PaymentBatchStatusEnum.Denied:
    case PaymentBatchStatusEnum.TreasuryDenied:
      displayText = BatchStatusForUI.Denied;
      labelColor = Colors.Danger600;
      break;
    case PaymentBatchStatusEnum.FundingInProgress:
      displayText =
        method == PaymentMethodEnum.Ach
          ? BatchStatusForUI.Processing
          : BatchStatusForUI.FundingInProgress;
      break;
    case PaymentBatchStatusEnum.Funded:
      displayText =
        method == PaymentMethodEnum.Ach ? BatchStatusForUI.Processing : BatchStatusForUI.Funded;
      labelColor = method == PaymentMethodEnum.Ach ? Colors.Neutral800 : Colors.Success600;
      break;
    case PaymentBatchStatusEnum.Failed:
      displayText = BatchStatusForUI.Failed;
      labelColor = Colors.Danger600;
      break;
    case PaymentBatchStatusEnum.ReadyForReview:
      displayText = BatchStatusForUI.ReadyForClientAuthorization;
      break;
    case PaymentBatchStatusEnum.ReadyForTreasuryReview:
      displayText = BatchStatusForUI.ReadyForReview;
      break;
    case PaymentBatchStatusEnum.Transmitted:
      labelColor = Colors.Success600;
      displayText = BatchStatusForUI.Transmitted;
      break;
    case PaymentBatchStatusEnum.Approved:
      displayText = BatchStatusForUI.Approved;
      labelColor = Colors.Success600;
      break;
    case PaymentBatchStatusEnum.Canceled:
      displayText = BatchStatusForUI.Canceled;
      break;
    default:
      displayText = BatchStatusForUI.Draft;
      break;
  }
  return {
    label: displayText,
    labelColor: labelColor || Colors.Neutral800,
  };
};

/**
 * Parses the batch filter values to the API compatible format
 * @param filteredValues user selected filter values
 * @returns
 */
export const parseBatchFilter = (filteredValues: Array<BatchStatusForUI>) => {
  return filteredValues.reduce((acc: PaymentServicePaymentBatchStatus[], item) => {
    const status = batchStatusFilterTypes.get(item);
    if (status) {
      acc = acc.concat(status);
    }
    return acc;
  }, []);
};
